import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { addItem, updateItem, deleteItem } from './helpers'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.highlights)


const highlightsReducer = (state = INIT_STATE, action) => {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.HIGHLIGHTS_ADD_ITEM:
            return addItem(state, action);
        case actionTypes.HIGHLIGHTS_UPDATE_ITEM:
            return updateItem(state, action);
        case actionTypes.HIGHLIGHTS_DELETE_ITEM:
            return deleteItem(state, action);
        default:
            return state;
    }
}

export default highlightsReducer